import type { Order } from "@src/api";

export const sortOrders = (orders: Order[]): Order[] => {
  // Разбиваем на две группы: 'request' и 'processing'
  const requestAndPickingOrders = orders.filter((order) => ["request", "picking"].includes(order.status));
  const otherOrders = orders.filter((order) => order.status !== "request" && order.status !== "picking");

  // Сортируем каждую группу по created от старого к новому
  const sortByCreated = (a: Order, b: Order, direction: "asc" | "desc" = "asc") => {
    return direction === "asc"
      ? new Date(a.created).getTime() - new Date(b.created).getTime()
      : new Date(b.created).getTime() - new Date(a.created).getTime();
  };

  requestAndPickingOrders.sort((a, b) => sortByCreated(a, b, "asc"));
  otherOrders.sort((a, b) => sortByCreated(a, b, "desc"));

  // Объединяем: сначала request, потом processing, потом остальные
  return [...requestAndPickingOrders, ...otherOrders];
};
